import axios from "axios";

/**
 * AI Credit Management API service (Super Admin + Client Admin).
 *
 * Talks only to the Node backend (base URL already includes /api/admin). Follows
 * the project _services convention: methods resolve with the response envelope
 * (`{ success, code, message, data }`) / reject with error.response.
 */
const BASE = "ai-credit";

function get(url, params) {
  return axios
    .get(url, params ? { params } : undefined)
    .then((r) => r.data)
    .catch((e) => Promise.reject(e.response));
}
function post(url, body) {
  return axios
    .post(url, body || {})
    .then((r) => r.data)
    .catch((e) => Promise.reject(e.response));
}
function put(url, body) {
  return axios
    .put(url, body || {})
    .then((r) => r.data)
    .catch((e) => Promise.reject(e.response));
}

export default {
  /* -------- Super Admin: rates -------- */
  listRates() {
    return get(`${BASE}/rates`);
  },
  upsertRate(reportType, payload) {
    return put(`${BASE}/rates/${reportType}`, payload);
  },
  bulkUpsertRates(rates) {
    return put(`${BASE}/rates`, { rates });
  },

  /* -------- Super Admin: cooperatives + funding -------- */
  listCooperatives(params) {
    return get(`${BASE}/cooperatives`, params);
  },
  topUp(organization, payload) {
    return post(`${BASE}/cooperatives/${organization}/top-up`, payload);
  },
  getPoolSettings(organization) {
    return get(`${BASE}/cooperatives/${organization}/settings`);
  },
  savePoolSettings(organization, payload) {
    return put(`${BASE}/cooperatives/${organization}/settings`, payload);
  },
  getHistory(organization, params) {
    return get(`${BASE}/cooperatives/${organization}/history`, params);
  },

  /* -------- Super Admin: usage log + feedback -------- */
  usageLog(params) {
    return get(`${BASE}/usage-log`, params);
  },
  feedback(params) {
    return get(`${BASE}/feedback`, params);
  },

  /* -------- Client Admin -------- */
  clientDashboard(params) {
    return get(`${BASE}/client/dashboard`, params);
  },
  getClientConfig() {
    return get(`${BASE}/client/config`);
  },
  saveClientConfig(payload) {
    return put(`${BASE}/client/config`, payload);
  },
  clientUsageLog(params) {
    return get(`${BASE}/client/usage-log`, params);
  },
  clientHistory(params) {
    return get(`${BASE}/client/history`, params);
  },

  /* -------- Report create screens: cost preview -------- */
  estimate(payload) {
    return post(`${BASE}/estimate`, payload);
  },
};
